/**
 * 主要用于解决打开抽屉组件，editor不更新内容的问题
 * 这里需要用到originEditorRef 记录原始的editor引用
 * @param cb 接收到抽屉组件开关状态后的回调函数
 */
export default (cb?: (toggle?: boolean) => void) => {
    return {
        data() {
            return {
                originEditorRef: {},
            };
        },
        methods: {
            /**
             * 监听抽屉组件的开关状态
             */
            onListenerDrawer(isDestroyed?: boolean) {
                if (isDestroyed) {
                    (this.$root as any).busRef.$off('handleDrawer');
                    return;
                }
                (this.$root as any).busRef.$on('handleDrawer', (toggle: boolean) => {
                    // 打开抽屉，重新渲染抽屉内的调试数据
                    if (toggle) {
                        this.$nextTick( () => {
                            (this.originEditorRef as any).alignCursors();
                        });
                    }
                });
            },
            /**
             * 初始化编辑器的引用
             * @editor 编辑器实例的引用
             */
            onMountedEditor(editor: any) {
                this.originEditorRef = editor;
            }
        },
        mounted() {
            this.onListenerDrawer();
        },
        beforeDestroy() {
            this.originEditorRef = null;
            this.onListenerDrawer(true);
        }
    }
}